import { changesFieldLabel } from '../const';
import '../styles.css';

export default function ChangesTable({ data }) {
  const getFieldLabel = (fieldName) => {
    const paymentsRegex = /^payments\[\d+\]\[(\w+)\]$/;
    const match = fieldName.match(paymentsRegex);
    if (match) {
      const field = match[1];
      if (field === 'percent_amount') return 'Percent Amount After Delivery';
      if (field === 'days_remaining') return 'Days Remaining After Delivery';
      return field.replace(/_/g, ' ');
    }
    return changesFieldLabel?.[fieldName] || fieldName.replace(/_/g, ' ');
  };

  return (
    <table id="changes-tbl">
      <thead>
        <tr>
          <th>Field Name</th>
          <th>From</th>
          <th>To</th>
        </tr>
      </thead>
      {console.log('data', data)}
      <tbody>
        {data?.changes?.text?.length > 0 &&
          data?.changes?.text.map((value, index) => (
            <tr>
              <td>{getFieldLabel(value.field_name)}</td>
              <td>{value.old_value}</td>
              <td>
                <b style={{ color: 'red' }}>{value.new_value}</b>
              </td>
            </tr>
          ))}

        {data?.changes?.supplier?.length > 0 &&
          data?.changes?.supplier.map((value, index) => (
            <tr>
              <td>{changesFieldLabel?.[`${value.field_name}`]}</td>
              <td>{value.old_supplier}</td>
              <td>
                <b style={{ color: 'red' }}>{value.new_supplier}</b>
              </td>
            </tr>
          ))}

        {data?.changes?.vat_exemption?.length > 0 &&
          data?.changes?.vat_exemption.map((value, index) => (
            <tr>
              <td>{changesFieldLabel?.[`${value.field_name}`]}</td>
              <td>{value.old_value_text}</td>
              <td>
                <b style={{ color: 'red' }}>{value.new_value_text}</b>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}
